// src/hooks/useSubcategories.js
import { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux"; 
import { setSubcategories } from "../Redux/subcategorySlice";
import { fetchSubcategories } from "../utils/fetcher";

export function useSubcategories() {
  const dispatch = useDispatch();
  const { subcategories, isLoaded } = useSelector((state) => state.subcategory);
  const [subcategoriesLoading, setSubcategoriesLoading] = useState(false);

  const refetchSubcategories = useCallback(() => {
    if (!isLoaded) {
      setSubcategoriesLoading(true);
    }
    return fetchSubcategories()
      .then((data) => {
        dispatch(setSubcategories(data));
        setSubcategoriesLoading(false);
        return data;
      })
      .catch((err) => {
        setSubcategoriesLoading(false);
        throw err;
      });
  }, [dispatch, isLoaded]);

  useEffect(() => {
    // Always fetch on mount to keep data fresh, but only show loading state if it's the first time
    refetchSubcategories();
    // We intentionally only want this to run on mount, so we disable the exhaustive-deps rule
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const findSubcategory = useCallback(
    (id) => {
      return subcategories.find((item) => item.id === id);
    },
    [subcategories]
  );

  return {
    subcategories,
    subcategoriesLoading,
    findSubcategory,
    refetchSubcategories,
  };
}
